export default "__VITE_ASSET__$Gx32VRzbD2MbzLlPhUPZQ__"